import { useTranslation } from 'react-i18next';
import { z } from 'zod';

export function MassSelectionSchema() {
  const { t } = useTranslation('invoicing/batchInvoices');

  const schema = z.object({
    massSelection: z.string().refine(value => /^\d+(?:;\d+)*;?$/.test(value), {
      message: t('massSelectionInvalid'),
    }),
  });

  return schema;
}

export type MassSelectionForm = z.infer<ReturnType<typeof MassSelectionSchema>>;
